export { default, type FoodAreasListProps } from './FoodAreasList';
